module.exports = __webpack_public_path__ + "static/screen-4feb28c8473a32811210be13ab8b984d.svg";